import Phaser from 'phaser';

import { AnimationRegistry } from '../assets/AnimationRegistry';

import { AssetGenerator } from '../assets/AssetGenerator';

import { ALL_TEXTURE_KEYS } from '../assets/assetKeys';

import {

  AUDIO_KEYS,

  EXTERNAL_AUDIO,

  EXTERNAL_SFX_MANIFEST,

  EXTERNAL_SPRITE_MANIFEST,

} from '../assets/externalAssets';

import { COLORS, GAME_HEIGHT, GAME_WIDTH, SCENE_KEYS } from '../data/gameConstants';
import { UIStyle } from '../ui/UIStyle';



export class PreloadScene extends Phaser.Scene {

  private progressBar?: Phaser.GameObjects.Graphics;

  private percentText?: Phaser.GameObjects.Text;



  constructor() {

    super({ key: 'PreloadScene' });

  }



  init(): void {

    this.cameras.main.setBackgroundColor(COLORS.BACKGROUND);

    this.createLoadingUI();

  }



  preload(): void {

    this.load.on('progress', (value: number) => {

      this.updateProgress(value * 0.88);

    });



    EXTERNAL_SPRITE_MANIFEST.forEach(({ key, url }) => {

      this.load.image(key, url);

    });

    this.load.audio(AUDIO_KEYS.AMBIENT, EXTERNAL_AUDIO.ambient);

    EXTERNAL_SFX_MANIFEST.forEach(({ key, url }) => {
      this.load.audio(key, url);
    });

  }



  create(): void {

    const missing = ALL_TEXTURE_KEYS.filter((key) => !this.textures.exists(key));



    if (missing.length > 0) {

      this.percentText?.setText('Fallback aset…');

      AssetGenerator.generateAll(this, (progress) => {

        this.updateProgress(0.88 + progress * 0.12);

      });

    } else {

      this.updateProgress(1);

    }



    AnimationRegistry.registerAll(this);

    this.time.delayedCall(200, () => {

      this.scene.start(SCENE_KEYS.MAIN_MENU);

    });

  }



  private createLoadingUI(): void {

    const width = GAME_WIDTH;

    const height = GAME_HEIGHT;



    this.add.graphics()

      .fillStyle(COLORS.PRIMARY, 0.8)

      .fillRoundedRect(width / 2 - 160, height / 2 - 25, 320, 50, 8);



    this.progressBar = this.add.graphics();



    this.add.text(width / 2, height / 2 - 60, 'Memuat SEISM...', {
      ...UIStyle.onDarkPanel(UIStyle.px(24), '#ffffff', true),
    }).setOrigin(0.5);

    this.percentText = this.add.text(width / 2, height / 2, '0%', {
      ...UIStyle.onDarkPanel(UIStyle.px(20), '#ffffff', true),
    }).setOrigin(0.5);

    this.add.text(width / 2, height / 2 + 50, 'Memuat aset kustom...', {
      ...UIStyle.panelMuted(UIStyle.px(15)),
    }).setOrigin(0.5);

  }



  private updateProgress(value: number): void {

    const width = GAME_WIDTH;

    const height = GAME_HEIGHT;

    const clamped = Phaser.Math.Clamp(value, 0, 1);



    this.progressBar?.clear();

    this.progressBar?.fillStyle(COLORS.ACCENT, 1);

    this.progressBar?.fillRoundedRect(

      width / 2 - 150,

      height / 2 - 15,

      300 * clamped,

      30,

      6,

    );

    this.percentText?.setText(`${Math.round(clamped * 100)}%`);

  }

}


